import {createAction} from 'redux-actions';
import RemoteServices from '~/constants/RemoteServices';
import MMSClient from 'mms_client_js';
import {
  getAnchorStyleId,
  isAnchorCompatibleStylesLoaded
} from '~/selectors/ProductSelectors';

const mms = new MMSClient(`${RemoteServices.products}/api/out`);

export const types = {
  FETCH: 'compatibleStyles/FETCH_COMPATIBLE_STYLES',
  FETCH_SUCCESS: 'compatibleStyles/FETCH_COMPATIBLE_STYLES_SUCCESS',
  FETCH_ERROR: 'compatibleStyles/FETCH_COMPATIBLE_STYLES_ERROR'
};

const fetchCompatibleStyles = createAction(types.FETCH);
const compatibleStylesSuccess = createAction(types.FETCH_SUCCESS);
const compatibleStylesError = createAction(types.FETCH_ERROR);

export function loadAnchorCompatibleStyles() {
  return (dispatch, getState) => {
    const state = getState();
    if (!isAnchorCompatibleStylesLoaded(state)) {
      const styleId = getAnchorStyleId(state);
      loadCompatibleStyles(styleId)(dispatch);
    }
  };
}

export const loadCompatibleStyles = styleId => dispatch => {
  dispatch(fetchCompatibleStyles(styleId));
  return mms.getCompatibleStyles(styleId).then(
    data =>
      dispatch(compatibleStylesSuccess({styleId, compatibleStyles: data})),
    err => {
      err.styleId = styleId;
      dispatch(compatibleStylesError(err));
    }
  );
};
